import { jsx as _jsx } from "react/jsx-runtime";
import { ScheduleItem } from './components/scheduleItem/scheduleItem';
import { ScheduleProvider } from './schedule.context';
export const ScheduleView = () => (_jsx(ScheduleProvider, { children: _jsx(ScheduleItem, {}) }));
